module.exports = __webpack_public_path__ + "img/home_pic_up_2.d27177e0.png";